import React from 'react'
import { Link } from 'react-router-dom'
import './Footer.css'

const FOOTER_COLUMNS = [
  {
    title: 'Calculators',
    links: [
      { name: 'Age Calculator', path: '/age/' },
      { name: 'Percentage Calculator', path: '/percentage/' },
      { name: 'Retirement Age Calculator', path: '/retirement-age-calculator/' },
      { name: 'Pet Age Calculator', path: '/pet-age-calculator/' },
      { name: 'GPA Calculator', path: '/gpa-calculator/' },
      { name: 'Discount Calculator', path: '/discount-calculator/' },
    ],
  },
  {
    title: 'Text & Developer',
    links: [
      { name: 'Word Counter', path: '/word-counter/' },
      { name: 'JSON Formatter', path: '/json-formatter/' },
      { name: 'Text to Speech', path: '/text-to-speech/' },
      { name: 'QR Code Generator', path: '/qr-generator/' },
      { name: 'Password Generator', path: '/password/' },
    ],
  },
  {
    title: 'Image & Media',
    links: [
      { name: 'Image Compressor', path: '/image-compressor/' },
      { name: 'Image Converter', path: '/image-converter/' },
      { name: 'YouTube Thumbnail', path: '/yt-thumbnail/' },
    ],
  },
  {
    title: 'Company',
    links: [
      { name: 'About', path: '/about/' },
      { name: 'Contact', path: '/contact/' },
      { name: 'Blog', path: '/blog/' },
      { name: 'FAQ', path: '/faq/' },
      { name: 'Help', path: '/help/' },
      { name: 'Privacy Policy', path: '/privacy-policy/' },
      { name: 'Terms of Service', path: '/terms-of-service/' },
    ],
  },
]

const Footer = () => {
  const year = new Date().getFullYear()
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-grid">
          {FOOTER_COLUMNS.map((col) => (
            <div key={col.title} className="footer-column">
              <h3 className="footer-column-title">{col.title}</h3>
              <ul className="footer-column-list">
                {col.links.map((link) => (
                  <li key={link.path}>
                    <Link to={link.path} className="footer-link">
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {year} EveryKits. All rights reserved.
          </p>
          <p className="footer-powered">
            Built by{' '}
            <a
              href="https://traindevs.netlify.app"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
            >
              TrainDevs
            </a>
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer